export const FETCH_SUPPORT_CHAT_MODULE_TAGS =
  'SupportChatModuleTags/FETCH_SUPPORT_CHAT_MODULE_TAGS';
export const SET_SUPPORT_CHAT_MODULE_TAGS =
  'SupportChatModuleTags/SET_SUPPORT_CHAT_MODULE_TAGS';
export const DELETE_SUPPORT_CHAT_MODULE_TAG =
  'SupportChatModuleTags/DELETE_SUPPORT_CHAT_MODULE_TAG';
export const UPDATE_SUPPORT_CHAT_MODULE_TAG =
  'SupportChatModuleTags/UPDATE_SUPPORT_CHAT_MODULE_TAG';
export const SUPPORT_CHAT_MODULE_TAGS_LOADING =
  'SupportChatModuleTags/SUPPORT_CHAT_MODULE_TAGS_LOADING';
export const SUPPORT_CHAT_MODULE_TAG_UPDATING =
  'SupportChatModuleTags/SUPPORT_CHAT_MODULE_TAG_UPDATING';
export const ADD_SUPPORT_CHAT_MODULE_TAG =
  'SupportChatModuleTags/ADD_SUPPORT_CHAT_MODULE_TAG';

export const fetchSupportChatModuleTags = () => ({
  type: FETCH_SUPPORT_CHAT_MODULE_TAGS,
});

export const setSupportChatModuleTags = data => ({
  type: SET_SUPPORT_CHAT_MODULE_TAGS,
  data,
});

export const deleteSupportChatModuleTag = data => ({
  type: DELETE_SUPPORT_CHAT_MODULE_TAG,
  data,
});

export const updateSupportChatModuleTag = data => ({
  type: UPDATE_SUPPORT_CHAT_MODULE_TAG,
  data,
});

export const setSupportChatModuleTagsLoading = data => ({
  type: SUPPORT_CHAT_MODULE_TAGS_LOADING,
  data,
});

export const setSupportChatModuleTagUpdating = data => ({
  type: SUPPORT_CHAT_MODULE_TAG_UPDATING,
  data,
});

export const addSupportChatModuleTag = data => ({
  type: ADD_SUPPORT_CHAT_MODULE_TAG,
  data,
});

// Selectors:
export const retrieveSupportChatModuleTags = ({ supportChatModuleTags }) =>
  supportChatModuleTags.supportChatModuleTags;
